import React from "react";

// The built-in Form control with select from "react-bootstrap" was not playing well with other elements
// so I've created the style my-query-builder-select to look like a bootstrap select form control
// but play well with other elements.
const BootstrapValueSelector = ({
  className,
  handleOnChange,
  options,
  value,
  title,
}) => (
  <select
    title={title}
    className={`my-query-builder-select ${className}`}
    value={value}
    onChange={(e) => handleOnChange(e.target.value)}
  >
    {options.map((option) => {
      const key = option.id ? `key-${option.id}` : `key-${option.name}`;
      return (
        <option key={key} value={option.name}>
          {option.label}
        </option>
      );
    })}
  </select>
);

BootstrapValueSelector.displayName = "BootstrapValueSelector";

export default BootstrapValueSelector;
